module.exports = __webpack_public_path__ + "img/18_25.dda434b6.png";